module.exports = __webpack_public_path__ + "img/3-map.87fcbf29.jpg";